import React from "react";

const EmptyCourseBadges: React.FC = () => (
  <div className="bd-empty" id="coursesEmpty">
    <div className="bd-empty-art" aria-hidden="true">
      <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="60"
          cy="60"
          r="52"
          fill="var(--cream-ink)"
          stroke="var(--plum)"
          strokeWidth="2.5"
        />
        <circle
          cx="60"
          cy="60"
          r="52"
          fill="none"
          stroke="var(--grey-300)"
          strokeWidth="2.5"
          strokeDasharray="6 8"
          opacity=".7"
        />
        <path
          d="M60 34 L66 52 L85 52 L70 64 L75 82 L60 71 L45 82 L50 64 L35 52 L54 52 Z"
          fill="none"
          stroke="var(--grey-300)"
          strokeWidth="2.5"
          strokeLinejoin="round"
        />
      </svg>
    </div>
    <h3 className="bd-empty-title">No course badges yet</h3>
    <p className="bd-empty-text">
      Every course has badges to collect. Start one and your first will be along
      quicker than you'd think.
    </p>
    <div className="bd-empty-cta">
      <a href="/courses" className="btn btn-blue">
        Find a course to start &rarr;
      </a>
      <a href="/pricing" className="btn btn-outline">
        See the All Access Pass
      </a>
    </div>
  </div>
);

export default EmptyCourseBadges;
